import { AxiosResponse } from "axios";
import { OrganizationalStructureDispatch } from "./organizationalStructureStore";
import { Api } from "services/api/api.service";
import { OrganizationalStructureState } from "./organizationalStructureStore.reducers";
import { OrgWorker } from "model/OrganizationalStructure";

const getTeamMembers =
  (dispatch: OrganizationalStructureDispatch) =>
  async (
    companyId: number,
    teamId: number,
    page: number,
    pageSize: number
  ): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.fetchTeamMembers(
        companyId,
        teamId,
        page,
        pageSize
      )
      .then((res: any) => {
        dispatch({
          type: "GET_TEAM_MEMBERS",
          payload: { workGroupId: teamId, members: res.data.workers },
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when getting workgroup members", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };

const getUnassignedWorkers =
  (dispatch: OrganizationalStructureDispatch) =>
  async (
    companyId: number,
    page: number,
    pageSize: number
  ): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.fetchUnassignedWorkers(
        companyId,
        page,
        pageSize
      )
      .then((res: any) => {
        dispatch({
          type: "GET_UNASSIGNED_WORKERS",
          payload: res.data.workers,
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when getting workgroup members", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };

const assignWorkerToTeam =
  (dispatch: OrganizationalStructureDispatch) =>
  async (
    companyId: number,
    teamId: number,
    workerId: number
  ): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.assignWorkerToTeam(
        companyId,
        teamId,
        workerId
      )
      .then((res: any) => {
        dispatch({
          type: "UPDATE_TEAM_MEMBERS",
          payload: { workGroupId: teamId, worker: res.data },
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when updating workgroup members", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };

const createTeam =
  (dispatch: OrganizationalStructureDispatch) =>
  async (
    companyId: number,
    name: string,
    companyUnitId: number
  ): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.createTeam(
        companyId,
        name,
        companyUnitId
      )
      .then((res: any) => {
        console.log(res);
        dispatch({
          type: "CREATE_TEAM",
          payload: { companyUnitId: companyUnitId, team: res.data },
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when creating workgroup", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };

const createEntity =
  (dispatch: OrganizationalStructureDispatch) =>
  async (companyId: number, name: string): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.createEntity(companyId, name)
      .then((res: any) => {
        dispatch({
          type: "CREATE_ENTITY",
          payload: { entity: res.data },
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when creating workgroup", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };

const createUnit =
  (dispatch: OrganizationalStructureDispatch) =>
  async (
    companyId: number,
    entityId: number,
    name: string
  ): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.createUnit(companyId, entityId, name)
      .then((res: any) => {
        dispatch({
          type: "CREATE_UNIT",
          payload: { companyEntityId: entityId, unit: res.data },
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when creating unit", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };
const deleteUnit =
  (dispatch: OrganizationalStructureDispatch) =>
  async (
    companyId: number,
    entityId: number,
    unitId: number
  ): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.deleteUnit(companyId, entityId, unitId)
      .then((res: any) => {
        dispatch({
          type: "DELETE_UNIT",
          payload: { companyEntityId: entityId, unitId: unitId },
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when creating unit", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };
const deleteEntity =
  (dispatch: OrganizationalStructureDispatch) =>
  async (companyId: number, entityId: number): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.deleteEntity(companyId, entityId)
      .then((res: any) => {
        dispatch({
          type: "DELETE_ENTITY",
          payload: { entityId: entityId },
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when creating unit", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };

const deleteTeam =
  (dispatch: OrganizationalStructureDispatch) =>
  async (
    companyId: number,
    unitId: number,
    workgroupId: number
  ): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.deleteTeam(companyId, workgroupId)
      .then((res: any) => {
        dispatch({
          type: "DELETE_TEAM",
          payload: { companyUnitId: unitId, workgroupId: workgroupId },
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when creating unit", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };

const updateTeam =
  (dispatch: OrganizationalStructureDispatch) =>
  async (
    companyId: number,
    workGroupId: number,
    name: string,
    companyUnitId?: number
  ): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.updateTeam(
        companyId,
        workGroupId,
        name,
        companyUnitId
      )
      .then((res: any) => {
        dispatch({
          type: "UPDATE_TEAM",
          payload: { teamId: workGroupId, name, companyUnitId },
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when updating workgroup", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };

const updateEntity =
  (dispatch: OrganizationalStructureDispatch) =>
  async (
    companyId: number,
    entityId: number,
    name: string
  ): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.updateEntity(companyId, entityId, name)
      .then((res: any) => {
        dispatch({
          type: "UPDATE_ENTITY",
          payload: { entityId, name },
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when updating workgroup", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };

const updateUnit =
  (dispatch: OrganizationalStructureDispatch) =>
  async (
    companyId: number,
    entityId: number,
    unitId: number,
    name: string
  ): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.updateUnit(
        companyId,
        entityId,
        unitId,
        name
      )
      .then((res: any) => {
        dispatch({
          type: "UPDATE_UNIT",
          payload: { entityId, unitId, name },
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when updating workgroup", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };

const createWorker =
  (dispatch: OrganizationalStructureDispatch) =>
  async (companyId: number, data: any): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.createWorker(companyId, data)
      .then((res: any) => {
        dispatch({
          type: "ADD_WORKER_TO_STRUCTURE",
          payload: res.data,
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: any) => {
        let errorMessage = "Unknown error occurred";

        if (e.response && e.response.data) {
          errorMessage = e.response.data.errorMessage;
        }

        dispatch({
          type: "SET_REQUEST_ERROR",
          payload: { message: errorMessage, err: e },
        });

        return Promise.reject({
          ...e,
          errorMessage,
        });
      });
    return res;
  };

const updateWorker =
  (dispatch: OrganizationalStructureDispatch) =>
  async (
    companyId: number,
    workerId: number,
    data: any
  ): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.updateWorker(companyId, workerId, data)
      .then((res: any) => {
        dispatch({
          type: "UPDATE_WORKER",
          payload: res.data,
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when updating workgroup", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };

const deleteWorker =
  (dispatch: OrganizationalStructureDispatch) =>
  async (companyId: number, workerId: number): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.deleteWorker(companyId, workerId)
      .then((res: any) => {
        dispatch({
          type: "DELETE_WORKER",
          payload: workerId,
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error when updating workgroup", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };

const toggleTeam =
  (dispatch: OrganizationalStructureDispatch) => (teamId: number) => {
    dispatch({ type: "TOGGLE_TEAM", payload: teamId });
  };

const updateTeamStateMembers =
  (dispatch: OrganizationalStructureDispatch) =>
  (
    teamId: number,
    members: OrgWorker[],
    currentPage: number,
    totalPages: number
  ) => {
    dispatch({
      type: "UPDATE_TEAM_STATE_MEMBERS",
      payload: { teamId, members, currentPage, totalPages },
    });
  };

const setTeamLoading =
  (dispatch: OrganizationalStructureDispatch) => (loading: boolean) => {
    dispatch({ type: "SET_TEAM_LOADING", payload: loading });
  };

const updateTeamPagination =
  (dispatch: OrganizationalStructureDispatch) =>
  (teamId: number, page: number) => {
    dispatch({
      type: "UPDATE_TEAM_PAGINATION",
      payload: { teamId, page },
    });
  };

const unassignWorkerFromWorkGroup =
  (dispatch: OrganizationalStructureDispatch) =>
  async (
    companyId: number,
    workGroupId: number,
    workerId: number
  ): Promise<AxiosResponse<any>> => {
    dispatch({ type: "SET_IS_LOADING", payload: true });

    const res = await Api()
      .company.organizationalStructure.unassignWorkerFromWorkGroup(
        companyId,
        workGroupId,
        workerId
      )
      .then((res: any) => {
        dispatch({
          type: "UNASSIGN_WORKER_FROM_WORKGROUP",
          payload: { workerId, workGroupId },
        });
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.resolve(res);
      })
      .catch((e: Error) => {
        console.error("Error unassign worker from workgroup", e);
        dispatch({ type: "SET_IS_LOADING", payload: false });
        return Promise.reject();
      });
    return res;
  };

export const organizationalStructureActions = (
  dispatch: OrganizationalStructureDispatch,
  state: OrganizationalStructureState
) => ({
  getTeamMembers: getTeamMembers(dispatch),
  assignWorkerToTeam: assignWorkerToTeam(dispatch),
  createTeam: createTeam(dispatch),
  createEntity: createEntity(dispatch),
  createUnit: createUnit(dispatch),
  deleteTeam: deleteTeam(dispatch),
  deleteEntity: deleteEntity(dispatch),
  deleteUnit: deleteUnit(dispatch),
  updateEntity: updateEntity(dispatch),
  updateTeam: updateTeam(dispatch),
  updateUnit: updateUnit(dispatch),
  createWorker: createWorker(dispatch),
  deleteWorker: deleteWorker(dispatch),
  updateWorker: updateWorker(dispatch),
  toggleTeam: toggleTeam(dispatch),
  updateTeamStateMembers: updateTeamStateMembers(dispatch),
  setTeamLoading: setTeamLoading(dispatch),
  getUnassignedWorkers: getUnassignedWorkers(dispatch),
  updateTeamPagination: updateTeamPagination(dispatch),
  unassignWorkerFromWorkGroup: unassignWorkerFromWorkGroup(dispatch),
});
